module.exports = __webpack_public_path__ + "static/Matrix-592e819f6206d824d05ab652ab0fce03.jpg";